import { useState, useEffect } from "react";

const MOBILE_QUERY = "(max-width: 768px)";

export default function useIsMobile() {
    const [isMobile, setIsMobile] = useState(
        // On the server, __WZ_SSR_MOBILE__ is set when pre-rendering the mobile
        // markup, so hydration on phones sees the same initial branch.
        () => (typeof window !== "undefined" ? window.matchMedia(MOBILE_QUERY).matches : !!globalThis.__WZ_SSR_MOBILE__),
    );

    useEffect(() => {
        const mql = window.matchMedia(MOBILE_QUERY);
        const handleChange = (e) => setIsMobile(e.matches);
        mql.addEventListener("change", handleChange);
        return () => mql.removeEventListener("change", handleChange);
    }, []);

    return isMobile;
}
